<template>
  <div class="media-type" :class="[className, obj.type]" :id="videoId">
    <vimeo-player  v-if="obj.type === 'vimeo'" ref="vimeo" class="video-vimeo" :video-id="videoId" :options="vimeoOptions"  :muted="true"  @ready="readyVIM"  @playing="playVideoVim"
                   @pause="pauseVim"
                   @ended="pauseVim"
    />
    <youtube v-if="obj.type === 'youtube'" :player-vars="playerVars" class="video-youtube"  id="player" :video-id="videoId" ref="youtube" @ready="readyYT" @playing="playVideo" @ended="stopVideo"></youtube>



    <img v-if="obj.type === 'img'" :src="obj.img" :alt="dynAlt">
    <!--img v-if="obj.type === 'img' && thumb" :src="'https://nossavisao.pt/landingpages/resize/index.php?img=' + obj.img" :alt="dynAlt"-->

    <img v-if="obj.type === 'samedesktop'" :src="objDesk.img" :alt="dynAlt">

    <video v-if="obj.type === 'vid'" muted autoplay playsinline loop preload :class="{'full' : full}">
      <source :src="obj.vid" type="video/mp4">

    </video>


    <div class="media-type-overlay" v-if="obj.overlay != '0' && obj.overlay != '' && obj.overlay != null"  v-bind:style="styleOver">

    </div>

    <div class="refsize" v-if="full"></div>

  </div>
</template>

<script>


import {EVENTBUS} from '../../main';
//https://www.npmjs.com/package/vue-youtube
//https://www.npmjs.com/package/vue-vimeo-player
import VueYoutube from 'vue-youtube';
import vueVimeoPlayer from 'vue-vimeo-player'
import Vue from 'vue'
Vue.use(VueYoutube)
Vue.use(vueVimeoPlayer)


export default {

  name: 'media-type',
  props:['className', 'obj', 'dynAlt', 'objDesk', 'full', 'thumb', 'testvid'],
  data() {

    return {
      videoId: '',

      playerVars: {
        origin: 1,
        enablejsapi: 1,
       // autoplay: 1,
       // controls: 0,
        rel : 0,
        fs : 0,
       // loop : 1,
      //  muted: 1,
        showinfo: 0,
        autohide: 1,
        disablekb: 1,
        modestbranding: 1,
        iv_load_policy: 3,
        playsinline:1,
        style : 'pointer-events: none',


       // opa: parseInt(this.obj.overlay) / 100,

      },

      vimeoOptions:{

        height: '100px',
      },

      styleOver: {
        opacity: 0

      },
    }
  },

  computed: {

    player() {


      let ret = {};

      if(this.obj.type === 'youtube'){
        ret =  this.$refs.youtube.player;
      }else{
        ret =  this.$refs.vimeo.player;
      }



     return ret;
    }
  },

  created() {



 //   alert(this.className)








    if(this.obj.type === 'youtube'){
      this.videoId = this.obj.youtube;
    }
    if(this.obj.type === 'vimeo'){
      this.videoId = this.obj.vimeo;
      this.style = 'pointer-events: auto';


    }

   // console.log(this.obj.overlay)

    if(this.obj.overlay != '0'){

      this.styleOver.opacity = parseInt(this.obj.overlay) / 100;
    }






  },
  mounted() {




     EVENTBUS.$on('stopVideo', this.stopVideo);
    //EVENTBUS.$emit('AAA', 0);

  },

  destroyed() {

  },

  methods: {



    init() {


    },

    async playVideo(){
      await this.player.playVideo();
    },


    stopVideo(isMe = {}) {

      //this.player.playVideo();
      // Mute?!
      console.log('stopVideo')

      try{

        if(isMe != this){
          this.player.pause();
        }
      }catch (e) {
        console.log('fodeu')
      }

    //  this.player.setVolume(0);

    },

    playVideoVim(){
      EVENTBUS.$emit('stopVideo', this);


      if(this.$route.name == 'project'&& this.className=="proj-media"){

        EVENTBUS.$emit('goPlay', 'inplay');
       // console.log(this.player)
       // this.player.fullscreenchange();

        //let elem = document.querySelector("video");

        /*
        let elem =   this.player

        if (!document.fullscreenElement) {
          elem.requestFullscreen().catch((err) => {
            alert(`Error attempting to enable fullscreen mode: ${err.message} (${err.name})`);
          });
        } else {
          document.exitFullscreen();
        }
         */

      }

    },

    pauseVim(){
      if(this.$route.name == 'project' && this.className=="proj-media") {

        EVENTBUS.$emit('goPlay', '');
      }
    },
    readyYT(event){

      this.player.playVideo();
      // Mute?!
      this.player.mute();
      this.player.setVolume(0);

      document.getElementsByTagName('iframe')[0].contentWindow.getElementsByClassName('ytp-watch-later-button')[0].style.display = 'none';
     // this.player = event.target

      //this.player.playVideo()
      //this.player.playVideo()

    },

    readyVIM(event){
      const _this = this;




      if(_this.className == 'proj-media'){


       // _this.player.playVideo();
       // _this.player.mute();
        setTimeout(function(){
          //_this.player.play();
         // _this.player.mute();


        }, 400)





      }

    }
  },
};

</script>


// WEBPACK FOOTER //
// src/components/Modules/MediaType.vue